module.exports = __webpack_public_path__ + "img/findb.071654a6.png";